import React from 'react';
import styled from 'styled-components';
import video1 from "../assets/video1.mp4";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  height: 100vh; 
  background: #000;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 0;

  @media (max-width: 768px) {
    height: auto; 
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const Header = styled.h1`
  font-size: 3.6rem;
  color: #fff;
  text-align: center;
  margin-top: 30px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16/9;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
  background-color: black; /* Set background color to black behind the video */

  @media (max-width: 768px) {
    max-width: 100%;
    aspect-ratio: 16/9;
  }

  @media (max-width: 480px) {
    aspect-ratio: 4/3;
  }
`;

const Construct = () => {
  return (
    <PageContainer>
      <Header>CONSTRUCTION UPDATE</Header>
      
      <VideoContainer>
        <iframe
          width="100%"
          height="100%"
          src={video1}
          title="Construction Update Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </VideoContainer>
    </PageContainer>
  );
};

export default Construct;
